<template>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        :value="value"
        :checked="isChecked"
        @change="updateValue"
        :id="value"
      />
      <label class="form-check-label" :for="value">{{ label }}</label>
    </div>
</template>

<script>
export default {
  name: "ProfileCheckboxMulti",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isChecked() {
      return this.modelValue.includes(this.value);
    },
  },
  methods: {
    updateValue(event) {
      const isChecked = event.target.checked;
      let newValue = [...this.modelValue];

      if (isChecked) {
        newValue.push(this.value);
      } else {
        newValue = newValue.filter(val => val !== this.value);
      }

      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>